define('drops/sketchPad/canvasMorph',[
    'jquery',
    'underscore',
    'lq',
    'lq/util'
], function ($, _, lq, util) {
    'use strict';

    function CanvasMorph(model, $canvas, $toolbar, $stylePickerContainer, parameters, reqDataFromParent, $actionWrapper) {
        var self = this;
        self.$canvas = $canvas;
        self.$stylePickerContainer = $stylePickerContainer;
        self.reqDataFromParent = reqDataFromParent;
        self.parameters = parameters;
        self.$actionWrapper = $actionWrapper;
        self._isUndoShown = false;
        self.showUndo = function () {
            self._isUndoShown = true;
            setButtonImage(self.btnUndo, true, false);
        };
        self.hideUndo = function () {
            self._isUndoShown = false;
            setButtonImage(self.btnUndo, false, false);
        };

        self._isRedoShown = false;
        self.showRedo = function () {
            self._isRedoShown = true;
            setButtonImage(self.btnRedo, true, false);
        };
        self.hideRedo = function () {
            self._isRedoShown = false;
            setButtonImage(self.btnRedo, false, false);
        };

        self._isGridShown = model.showGridInitially;
        self.showGrid = function () {
            self._isGridShown = true;
            setButtonImage(self.btnGrid, true, true);
            if (self.gridOnTop) {
                setButtonImage(self.btnOnTop, true, true);
            } else {
                setButtonImage(self.btnOnTop, true, false);
            }
        };
        self.hideGrid = function () {
            self._isGridShown = false;
            setButtonImage(self.btnGrid, true, false);
            if (self.gridOnTop) {
                setButtonImage(self.btnOnTop, false, true);
            } else {
                setButtonImage(self.btnOnTop, false, false);
            }
        };

        self.gridSize = model.startingGridSize || 3;

        self.realCurZoom = 0;
        self.curZoom = self.realCurZoom;
        self.setCurZoom = function (val) {
            self.lastX = self.canvas.width / 2;
            self.lastY = self.canvas.height / 2;
            if (val > self.realCurZoom) {
                zoom(Math.abs(val - self.realCurZoom));
            } else {
                zoom(-Math.abs(val - self.realCurZoom));
            }
        };

        self.clicks = new Array();
        self.undoneStrokes = new Array();

        self.startingLineSize = model.startingLineSize;
        if (model.startingLineSize) {
            self.lineSize = parseInt(model.startingLineSize);
        } else {
            self.lineSize = 3;
        }

        self.startingLineSizeMarker = model.startingLineSizeMarker;
        if (model.startingLineSizeMarker) {
            self.lineSizeMarker = parseInt(model.startingLineSizeMarker);
        } else {
            self.lineSizeMarker = 15;
        }

        self.curColor = model.defaultPenColor;
        self.curColorMarker = model.defaultMarkerColor;
        self.lastColor = "#000000";

        self.showPen = model.showPen;
        self.showMarker = model.showMarker;
        self.showMove = model.showMove;
        self.showDelete = model.showDelete;
        self.showClear = model.showClear;
        self.showLineSlider = model.showLineSlider;
        self.showGridSlider = model.showGridSlider;
        self.showScrollSlider = model.showScrollSlider;
        self.showGridOnTop = model.showGridOnTop;
        self.showUndoRedo = model.showUndoRedo;
        self.showGridInitially = model.showGridInitially;
        self.useGraphPaper = model.useGraphPaper;
        self.useGraphPaperScale = model.useGraphPaperScale;
        self.enablePinchMove = model.enablePinchMove;
        self.graphPaperScaleParameter = model.graphPaperScaleParameter;
        self.gridOnTop = model.gridOnTop;
        self.disableZooming = model.disableZooming;
        self.startingGridSize = model.startingGridSize;
        self.startingSensitivity = model.startingSensitivity;
        self.useBackImage = model.useBackImage;
        self.backImage = model.backImage;
        self.backImageOnTop = model.backImageOnTop;
        self.defaultMarkerColor = model.defaultMarkerColor;
        self.defaultPenColor = model.defaultPenColor;
        self.colorIndicesToAllow = model.colorIndicesToAllow;
        self.hasBgImage = model.useBackImage && model.backImage;
        self.disableMovingBg = model.disableMovingBg;

        self.hasHeader = self.showUndoRedo ||
            self.showGridOnTop ||
            self.showClear ||
            self.showDelete ||
            self.showMove ||
            self.showMarker ||
            self.showPen ||
            self.showGridInitially;

        self.penOpenedEvent = new CustomEvent('penOpened');
        self.markOpenedEvent = new CustomEvent('markOpened');

        self.paint = null;
        self.filenameToLoad = "";
        self.context = null;
        self.canvas = null;

        if (model.showPen) {
            self.curMode = "paint";
        } else if (model.showMarker) {
            self.curMode = "mark";
        } else if (!model.readOnly) {
            self.curMode = "paint";
        } else {
            self.curMode = "";
        }

        self.lastX = null;
        self.lastY = null;
        self.dragStart = null;
        self.dragged = null;
        self.scaleFactor = 1.1;
        self.pt = null;
        self.svg = null;
        self.lastTouchDistance = 0;
        self.deleteFromIndex = 0;
        self.deleteToIndex = 0;
        self.originalColorSelection = "";
        self.strokeSelected = false;
        self.moveCounter = 0;
        self.strokeSelectionSensitivity = 50;

        self.lastStrokeEndInd = 0;
        self.completedStrokesInd = new Array();

        self.btnDraw = { id: "imgDrawObj", srcActOn: "Drops/SketchPad/icons/draw-on.svg" };
        self.btnMarker = { id: "imgMarkerObj", srcActOn: "Drops/SketchPad/icons/marker-on.svg" };
        self.btnDelete = { id: "imgDeleteObj", srcActOn: "Drops/SketchPad/icons/erase-on.svg" };
        self.btnGrab = { id: "imgGrab", srcActOn: "Drops/SketchPad/icons/grab-on.png", srcActOff: "Drops/SketchPad/icons/grab-off.png" };
        self.btnClear = { id: "imgClear", srcActOn: "Drops/SketchPad/icons/clear-on.png", srcActOff: "Drops/SketchPad/icons/clear-on.png" };
        self.btnUndo = {
            id: "imgUndo", srcActOn: "Drops/SketchPad/icons/undo-act-on.png", srcActOff: "Drops/SketchPad/icons/undo-act-on.png",
            srcDeactOff: "Drops/SketchPad/icons/undo-deact.png"
        };
        self.btnRedo = {
            id: "imgRedo", srcActOn: "Drops/SketchPad/icons/redo-act-on.png", srcActOff: "Drops/SketchPad/icons/redo-act-on.png",
            srcDeactOff: "Drops/SketchPad/icons/redo-deact.png"
        };
        self.btnGrid = { id: "imgGrid", srcActOn: "/Drops/SketchPad/icons/grid-on.png", srcActOff: "Drops/SketchPad/icons/grid-off.png" };
        self.btnOnTop = {
            id: "imgOnTop", srcActOn: "Drops/SketchPad/icons/ontop-act-on.png", srcActOff: "Drops/SketchPad/icons/ontop-act-off.png",
            srcDeactOn: "Drops/SketchPad/icons/ontop-act-on.png", srcDeactOff: "Drops/SketchPad/icons/ontop-act-off.png"
        };

        self.mousedown = function (e) {
            //Firefox doesn't have e.offsetX
            self.lastX = (e.offsetX || e.layerX - e.currentTarget.offsetLeft);
            self.lastY = (e.offsetY || e.layerY - e.currentTarget.offsetTop);

            mousedownAction(e);

            e.preventDefault();
        };

        self.mousemove = function (e) {
            self.lastX = (e.offsetX || e.layerX - e.currentTarget.offsetLeft);
            self.lastY = (e.offsetY || e.layerY - e.currentTarget.offsetTop);

            mousemoveAction(e);
        };

        self.mouseup = function (e) {

            mouseupAction(e);
        };

        self.mouseout = function (e) {
            self.paint = false;
            self.dragStart = false;
            redraw();
        };

        self.mousewheel = function (e) {
            var delta = e.wheelDelta ? e.wheelDelta / 120 : e.detail ? -e.detail : 0;
            if (delta) {
                zoom(delta);
            }
            return e.preventDefault() && false;
        };

        self.touchstart = function (e) {
            e.preventDefault();

            if (e.touches.length < 2) {
                self.lastX = getTouchPoint(e.touches[0]).x;
                self.lastY = getTouchPoint(e.touches[0]).y;

                mousedownAction(e);
            }

            if (e.touches.length === 2) {
                cancelDelete();
                self.lastTouchDistance = getDistance(getTouchPoint(e.touches[0]), getTouchPoint(e.touches[1]));
                self.lastX = (getTouchPoint(e.touches[0]).x + getTouchPoint(e.touches[1]).x) / 2;
                self.lastY = (getTouchPoint(e.touches[0]).y + getTouchPoint(e.touches[1]).y) / 2;
                self.dragStart = self.context.transformedPoint(self.lastX, self.lastY);
                self.dragged = false;
            }
        };

        self.touchmove = function (e) {
            e.preventDefault();

            if (e.touches.length < 2) {
                self.lastX = getTouchPoint(e.touches[0]).x;
                self.lastY = getTouchPoint(e.touches[0]).y;

                mousemoveAction(e);
            }

            if (e.touches.length === 2) {
                cancelDelete();

                if (getDistance(getTouchPoint(e.touches[0]), getTouchPoint(e.touches[1])) > self.lastTouchDistance) {
                    zoom(1);
                } else if (getDistance(getTouchPoint(e.touches[0]), getTouchPoint(e.touches[1])) < self.lastTouchDistance) {
                    zoom(-1);
                }

                self.lastTouchDistance = getDistance(getTouchPoint(e.touches[0]), getTouchPoint(e.touches[1]));
                self.lastX = (getTouchPoint(e.touches[0]).x + getTouchPoint(e.touches[1]).x) / 2;
                self.lastY = (getTouchPoint(e.touches[0]).y + getTouchPoint(e.touches[1]).y) / 2;
                self.dragged = true;

                if (self.dragStart && self.enablePinchMove) {
                    var pt = self.context.transformedPoint(self.lastX, self.lastY);
                    self.context.translate(pt.x - self.dragStart.x, pt.y - self.dragStart.y);
                    redraw();
                }
            }
        };

        self.touchend = function (e) {
            e.preventDefault();

            if (e.touches.length < 2) {
                mouseupAction(e);
            }

            self.dragStart = null;
            self.paint = false;
        };

        self.touchColorpicker = function (e) {
            return false;
        };

        self.selectDraw = function (e) {
            if (is_touch_device() == true && e.type === 'click') { return };
            self.curMode = "paint";

            setButtonSvg(self.btnDraw, true);
            setButtonSvg(self.btnMarker, false);
            setButtonSvg(self.btnDelete, false);
            setButtonImage(self.btnGrab, true, false);
            setButtonImage(self.btnClear, true, false);

            self.$penTool[0].dispatchEvent(self.penOpenedEvent);
        };

        self.selectGrab = function () {
            self.curMode = "grab";

            setButtonSvg(self.btnDraw, false);
            setButtonSvg(self.btnMarker, false);
            setButtonSvg(self.btnDelete, false);
            setButtonImage(self.btnGrab, true, true);
            setButtonImage(self.btnClear, true, false);
        };

        self.selectDelete = function () {
            self.curMode = "delete";

            setButtonSvg(self.btnDraw, false);
            setButtonSvg(self.btnMarker, false);
            setButtonSvg(self.btnDelete, true);
            setButtonImage(self.btnGrab, true, false);
            setButtonImage(self.btnClear, true, false);
        };

        self.selectMarker = function (e) {
            if (is_touch_device() == true && e.type === 'click') { return };
            self.curMode = "mark";

            setButtonSvg(self.btnDraw, false);
            setButtonSvg(self.btnMarker, true);
            setButtonSvg(self.btnDelete, false);
            setButtonImage(self.btnGrab, true, false);
            setButtonImage(self.btnClear, true, false);

            self.$markerTool[0].dispatchEvent(self.markOpenedEvent);
        };

        self.clearDrawing = function () {
            if (self.context) {
                clearEverything();
            } else {
                const canvas = $canvas[0];
                self.context = canvas.getContext('2d');
                clearEverything();
            }

            self.lastStrokeEndInd = 0;
            self.completedStrokesInd = new Array();
            self.clicks = new Array();
        };

        self.selectClear = function () {
            setButtonImage(self.btnClear, true, true);

            if (!self.reqDataFromParent.isClearEventEnabled) {
                self.clearDrawing();
                redraw();
            }
            self.reqDataFromParent.triggerClearEventFunction();

            setTimeout(function () {
                setButtonImage(self.btnClear, true, false);
            }, 100);
        };

        self.toggleGrid = function (e) {
            if (is_touch_device() == true && e.type === 'click') { return };
            if (self._isGridShown) {
                self.hideGrid();
            } else {
                self.showGrid();
            }
            redraw();
        };

        self.toggleOnTop = function (e) {
            if (is_touch_device() == true && e.type === 'click') { return };
            if (self._isGridShown) {
                if (self.gridOnTop) {
                    self.gridOnTop = false;
                    setButtonImage(self.btnOnTop, true, false);
                } else {
                    self.gridOnTop = true;
                    setButtonImage(self.btnOnTop, true, true);
                }
                redraw();
            }
        };

        self.undo = function () {
            if (self._isUndoShown) {

                selectStroke(self.clicks.length - 1);
                deleteStroke();

                self.showRedo();

                if (self.clicks.length === 0) {
                    self.hideUndo();
                }
                redraw();

                if (self.reqDataFromParent.isOnUndoEventEnabled) {
                    self.reqDataFromParent.triggerOnUndoEventFunction();
                }
            }
        };

        self.undoMouseDown = function () {
            if (self._isUndoShown) {
                setButtonImage(self.btnUndo, true, true);
            }
        };

        self.undoMouseUpOrOut = function () {
            if (self._isUndoShown) {
                setButtonImage(self.btnUndo, true, false);
            }
        };

        self.undoTouch = function () {
            self.undo();
            self.undoMouseDown();
        };

        self.redo = function () {
            if (self._isRedoShown) {

                while (self.undoneStrokes[self.undoneStrokes.length - 1].length > 0) {
                    self.clicks.push(self.undoneStrokes[self.undoneStrokes.length - 1].shift());
                }

                self.undoneStrokes.pop();

                self.showUndo();

                if (self.undoneStrokes.length === 0) {
                    self.hideRedo();
                }
                redraw();

                if (self.reqDataFromParent.isOnRedoEventEnabled) {
                    self.reqDataFromParent.triggerOnRedoEventFunction();
                }
            }
        };

        self.redoMouseDown = function () {
            if (self._isRedoShown) {
                setButtonImage(self.btnRedo, true, true);
            }
        };

        self.redoMouseUpOrOut = function () {
            if (self._isRedoShown) {
                setButtonImage(self.btnRedo, true, false);
            }
        };

        self.redoTouch = function () {
            self.redo();
            self.redoMouseDown();
        };

        self.redraw = function (bgImgSrc, isNewBgImg, isClearBg) {
            redraw(bgImgSrc, isNewBgImg, isClearBg);
        };

        self.prevFuncCallWhileTouchScroll = function (functionCallback, e) {
            if (!self.scrolling) {
                functionCallback(e);
            }
        };

        function mousedownAction(e) {
            if (model.readOnly)
                return;
            if (self.curMode === "paint" || self.curMode === "mark") {
                self.paint = true;
                addClick(false);
                redraw();
            } else if (self.curMode === "grab") {
                self.dragStart = self.context.transformedPoint(self.lastX, self.lastY);
                self.dragged = false;
            } else if (self.curMode === "delete") {
                findStroke();
            }
        }

        function mousemoveAction(e) {
            if (self.paint && (self.curMode === "paint" || self.curMode === "mark")) {
                addClick(true);
                redraw();
            } else if (self.curMode === "grab") {
                self.dragged = true;
                if (self.dragStart) {
                    var pt = self.context.transformedPoint(self.lastX, self.lastY);
                    self.context.translate(pt.x - self.dragStart.x, pt.y - self.dragStart.y);
                    refreshLayers();
                    redraw();
                }
            } else if (self.curMode === "delete") {
                self.moveCounter += 1;
                if (self.moveCounter > 5) {
                    cancelDelete();
                }
            }
        }

        function mouseupAction(e) {
            if (self.curMode === "paint" || self.curMode === "mark") {
                self.paint = false;
            } else if (self.curMode === "grab") {
                self.dragStart = null;
                if (!self.dragged) {
                    zoom(e.shiftKey ? -1 : 1);
                }
            } else if (self.curMode === "delete") {
                if (self.strokeSelected) {
                    deleteStroke();
                }
                self.moveCounter = 0;
            }

            if (self.clicks.length > 0 && !self.clicks[self.clicks.length - 1].drag) {
                self.clicks.pop();
            }

            var lastStrokeEndIndOld = self.lastStrokeEndInd;

            redraw();

            if (self.reqDataFromParent.isOnReleaseEnabled && lastStrokeEndIndOld - self.lastStrokeEndInd !== 0) {
                self.reqDataFromParent.triggerOnReleaseEventFunction();
            }
        }

        function buildCanvas() {
            self.canvas = $canvas[0];
            self.canvas.height = self.canvas.clientHeight;
            self.canvas.width = self.canvas.clientWidth;

            self.context = self.canvas.getContext("2d");
            trackTransforms(self.context);

            createLayers();

            self.lastX = self.canvas.width / 2;
            self.lastY = self.canvas.height / 2;

            self.canvas.addEventListener("touchstart", self.touchstart);
            self.canvas.addEventListener("touchmove", self.touchmove);
            self.canvas.addEventListener("touchend", self.touchend);
            self.canvas.addEventListener("touchcancel", self.touchcancel);

            self.canvas.addEventListener("mousedown", self.mousedown);
            self.canvas.addEventListener("mousemove", self.mousemove);
            self.canvas.addEventListener("mouseup", self.mouseup);
            self.canvas.addEventListener("mouseout", self.mouseout);
            self.canvas.addEventListener("mousewheel", self.mousewheel);

            buildToolbar();

            var startPosition = self.context.transformedPoint(self.lastX, self.lastY);
            var pt = self.context.transformedPoint(self.lastX, self.lastY);
            self.context.translate(pt.x - startPosition.x, pt.y - startPosition.y);

            redraw();
        }
        self.buildCanvas = buildCanvas;

        function resizerRedraw(newWidth, newHeight) {
            self.$canvas.width(newWidth);
            self.$canvas.height(newHeight);
            self.canvas.height = self.canvas.clientHeight;
            self.canvas.width = self.canvas.clientWidth;
            if (self.$toolbarButtons)
                self.$toolbarButtons.width(newWidth);

            _.forEach(layers, function (layer) {
                layer.isInitialized = false;
            });
            redraw();
        }

        self.resizerRedraw = resizerRedraw;

        function buildToolbar() {
            var $toolbarButtons = $('<td id="canvas-morph-toolbar">')
                .css({
                    padding: '0px',
                    height: self.hasHeader ? '69px' : '',
                    textAlign: 'left',
                    verticalAlign: 'bottom',

                    whiteSpace: 'nowrap',
                    width: self.canvas.width,
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    position: 'relative',

                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignContent: 'space-between',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-end',
                }).on('scroll', function () {
                    self.scrolling = true;
                }).on('touchend', function () {
                    self.scrolling = false;
                });

            self.$toolbarButtons = $toolbarButtons;
            var $undoButton = $('<img id="imgUndo" />')
                .on('click', self.undo)
                .on('mousedown', self.undoMouseDown)
                .on('mouseup', self.undoMouseUpOrOut)
                .on('mouseout', self.undoMouseUpOrOut)
                .appendTo($toolbarButtons);
            var $redoButton = $('<img id="imgRedo" />')
                .on('click', self.redo)
                .on('mousedown', self.redoMouseDown)
                .on('mouseup', self.redoMouseUpOrOut)
                .on('mouseout', self.redoMouseUpOrOut)
                .appendTo($toolbarButtons);

            var $penTool =
                $('<div id="imgDraw" style="display: inline-block; position: relative;">'
                    + '<object id="imgDrawObj" />'
                    + '</div>')
                    .appendTo($toolbarButtons);
            $penTool
                .on('click', self.selectDraw.bind(self))
                .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.selectDraw));
            if (!self.showPen) {
                $penTool.hide();
            }
            self.$penTool = $penTool;
            $('<div id="pickDraw" class="sketchStylePicker sketchStylePickerPencil">'
                + '<input id="colPicker" type="hidden" />'
                + '<input type="hidden" name="lineSize" min="1" max="15" value="3"/>'
                + '</div>')
                .appendTo(self.$stylePickerContainer);

            var $markerTool =
                $('<div id="imgMarker" style="display: inline-block; position: relative;">'
                    + '<object id="imgMarkerObj" />'
                    + '</div>')
                    .appendTo($toolbarButtons);
            $markerTool
                .on('click', self.selectMarker.bind(self))
                .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.selectMarker));
            self.$markerTool = $markerTool;
            $('<div id="pickMark" class="sketchStylePicker sketchStylePickerMarker">'
                + '<input id="colPicker" type="hidden" />'
                + '<input type="hidden" name="lineSize" min="1" max="15" value="3"/>'
                + '</div>')
                .appendTo(self.$stylePickerContainer);

            var $deleteButton =
                $('<div id="imgDelete" style="display: inline-block; position: relative;">'
                    + '<object id="imgDeleteObj" />'
                    + '</div>')
                    .on('click', self.selectDelete)
                    .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.selectDelete))
                    .appendTo($toolbarButtons);
            var $moveButton = $('<img id="imgGrab" />')
                .on('click', self.selectGrab)
                .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.selectGrab))
                .appendTo($toolbarButtons);
            var $clearButton = $('<img id="imgClear" />')
                .on('click', self.selectClear)
                .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.selectClear))
                .appendTo($toolbarButtons);
            if (!self.showDelete) {
                $deleteButton.hide();
            }
            if (!self.showMove) {
                $moveButton.hide();
            }
            if (!self.showMarker) {
                $markerTool.hide();
            }
            if (!self.showClear) {
                $clearButton.hide();
            }
            if (!self.showUndoRedo) {
                var hiddenStyle = { 'display': 'none' }
                $undoButton.css(hiddenStyle);
                $redoButton.css(hiddenStyle);
            }

            $toolbarButtons.hide();

            var $toggleGridButton = $('<img id="imgGrid" />')
                .on('click', self.toggleGrid.bind(self))
                .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.toggleGrid))
                .appendTo($toolbarButtons);
            var $toggleOnTopButton = $('<img id="imgOnTop" />')
                .on('click', self.toggleOnTop.bind(self))
                .on('touchend', self.prevFuncCallWhileTouchScroll.bind(self, self.toggleOnTop))
                .appendTo($toolbarButtons);
            if (!self.showGridInitially) {
                $toggleGridButton.hide();
            }
            if (!self.showGridOnTop) {
                $toggleOnTopButton.hide();
            }

            $('<tr />')
                .append($toolbarButtons)
                .append($toolbarButtons)
                .append($toolbarButtons)
                .appendTo($toolbar);

            setButtonSvg(self.btnDraw, self.showPen, model.defaultPenColor);
            setButtonSvg(self.btnMarker, !self.showPen, model.defaultMarkerColor);
            setButtonImage(self.btnGrab, true, false);
            setButtonSvg(self.btnDelete, false);
            setButtonImage(self.btnClear, true, false);
            setButtonImage(self.btnUndo, false, false);
            setButtonImage(self.btnRedo, false, false);
            setButtonImage(self.btnGrid, true, model.showGridInitially);

            if (self.gridOnTop) {
                setButtonImage(self.btnOnTop, true, true);
            } else {
                setButtonImage(self.btnOnTop, true, false);
            }

            if (self.startingLineSize) {
                self.lineSize = self.startingLineSize;
            }

            if (self.startingLineSizeMarker) {
                self.lineSizeMarker = self.startingLineSizeMarker;
            }

            if (self.startingGridSize) {
                self.gridSize = self.startingGridSize;
            }

            if (self.startingSensitivity) {
                self.strokeSelectionSensitivity = self.startingSensitivity;
            }

            if (self.filenameToLoad) {
                loadSvgFile(self.filenameToLoad);       //if value fired first
            }

            insertStylePicker();

            setTimeout(function () {
                $toolbarButtons.show();
            }, 100);
        }

        function setButtonImage(button, active, on) {
            var selector = '#' + button.id;
            if (active && on) {
                self.$toolbarButtons.find(selector)[0].src = lq.getCdnUrl(button.srcActOn);
            } else if (active) {
                self.$toolbarButtons.find(selector)[0].src = lq.getCdnUrl(button.srcActOff);
            } else if (on) {
                self.$toolbarButtons.find(selector)[0].src = lq.getCdnUrl(button.srcDeactOn);
            } else {
                self.$toolbarButtons.find(selector)[0].src = lq.getCdnUrl(button.srcDeactOff);
            }
        }

        function setButtonSvg(button, on, defaultColor) {
            var selector = '#' + button.id;
            var toogleSvg = function () {
                if (on) {
                    self.$toolbarButtons.find(selector).parent().css('top', '0px');
                } else {
                    self.$toolbarButtons.find(selector).parent().css('top', '17.5px');
                }
            };
            if (!self.$toolbarButtons.find(selector)[0].contentDocument) {
                self.$toolbarButtons.find(selector).on('load', function () {
                    $(self.$toolbarButtons.find(selector)[0].contentDocument.getElementsByClassName("color")).attr("fill", defaultColor ? defaultColor : '');
                    toogleSvg();
                });
                self.$toolbarButtons.find(selector)[0].data = lq.getCdnUrl(button.srcActOn);
            } else {
                toogleSvg();
            }
        }

        function getOffsetLeft(elem) {
            var offsetLeft = 0;
            do {
                if (!isNaN(elem.offsetLeft)) {
                    offsetLeft += elem.offsetLeft;
                }
            } while (elem = elem.offsetParent);
            return offsetLeft;
        }

        function getOffsetTop(elem) {
            var offsetTop = 0;
            do {
                if (!isNaN(elem.offsetTop)) {
                    offsetTop += elem.offsetTop;
                }
            } while (elem = elem.offsetParent);
            return offsetTop;
        }

        function getTouchPoint(touch) {
            var scrollTop = parseFloat(self.$actionWrapper.scrollTop());
            var scrollLeft = parseFloat(self.$actionWrapper.scrollLeft());
            var borderLeft = parseFloat(self.$canvas.css('border-left-width'));
            var borderTop = parseFloat(self.$canvas.css('border-top-width'));
            return { x: touch.pageX - getOffsetLeft(self.canvas) + scrollLeft - (borderLeft ? borderLeft : 0),
                     y: touch.pageY - getOffsetTop(self.canvas) + scrollTop - (borderTop ? borderTop : 0)};
        }

        function getDistance(pt1, pt2) {
            var xs = pt2.x - pt1.x;
            xs = xs * xs;
            var ys = pt2.y - pt1.y;
            ys = ys * ys;

            return Math.sqrt(xs + ys);
        }

        function zoom(clicks) {
            if (!self.disableZooming) {
                if (self.realCurZoom + clicks < 16 && self.realCurZoom + clicks > -16) {
                    self.realCurZoom = self.realCurZoom + clicks;
                    var pt = self.context.transformedPoint(self.lastX, self.lastY);
                    self.context.translate(pt.x, pt.y);
                    var factor = Math.pow(self.scaleFactor, clicks);
                    self.context.scale(factor, factor);
                    self.context.translate(-pt.x, -pt.y);

                    refreshLayers();

                    redraw();
                }
            }
        }

        function addClick(dragging) {
            self.pt = self.context.transformedPoint(self.lastX, self.lastY);
            self.context.translate(self.pt.x, self.pt.y);

            if (self.clicks.length > 0 && !dragging && !self.clicks[self.clicks.length - 1].drag) {
                self.clicks.pop();
            }

            if (self.curMode === "mark") {
                self.clicks.push({ x: self.pt.x, y: self.pt.y, drag: dragging, size: self.lineSizeMarker, color: self.curColorMarker });
            }
            if (self.curMode === "paint") {
                self.clicks.push({ x: self.pt.x, y: self.pt.y, drag: dragging, size: self.lineSize, color: self.curColor });
            }

            self.showUndo();
            self.undoneStrokes.length = 0;
            self.hideRedo();
            self.context.translate(-self.pt.x, -self.pt.y);
        }

        function findStroke() {
            var i;

            self.pt = self.context.transformedPoint(self.lastX, self.lastY);

            var indexOfNearest = -1;

            for (i = 0; i < self.clicks.length; i++) {
                if ((getDistance({ x: self.clicks[i].x, y: self.clicks[i].y }, self.pt) < self.strokeSelectionSensitivity)
                    && (indexOfNearest < 0
                        || getDistance({ x: self.clicks[i].x, y: self.clicks[i].y }, self.pt)
                        < getDistance({ x: self.clicks[indexOfNearest].x, y: self.clicks[indexOfNearest].y }, self.pt))) {

                    indexOfNearest = i;
                }
            }

            selectStroke(indexOfNearest);
        }

        function selectStroke(indexOfNearest) {
            var i;

            if (indexOfNearest >= 0) {
                self.deleteFromIndex = indexOfNearest;
                self.deleteToIndex = indexOfNearest;
                for (i = indexOfNearest; self.clicks[i] && i >= 0 && self.clicks[i].drag; i--) {
                    self.deleteFromIndex = i - 1;
                }
                for (i = indexOfNearest; self.clicks[i + 1] && self.clicks[i + 1].drag; i++) {
                    self.deleteToIndex = i + 1;
                }
                self.originalColorSelection = self.clicks[indexOfNearest].color;
                var selectionColor = colorLuminance(self.clicks[indexOfNearest].color, 0.4);
                for (i = self.deleteFromIndex; self.clicks[i] && i < self.deleteToIndex + 1; i++) {
                    self.clicks[i].color = selectionColor;
                }
                self.strokeSelected = true;
                redraw();
            }
        }

        function cancelDelete() {
            var i;

            if (self.strokeSelected) {
                for (i = self.deleteFromIndex; self.clicks[i] && i < self.deleteToIndex + 1; i++) {
                    self.clicks[i].color = self.originalColorSelection;
                }
                self.strokeSelected = false;
                redraw();
            }
        }

        function deleteStroke() {
            var i;

            self.undoneStrokes.push(self.clicks.splice(self.deleteFromIndex, self.deleteToIndex - self.deleteFromIndex + 1));
            for (i = 0; i < self.undoneStrokes[self.undoneStrokes.length - 1].length; i++) {
                self.undoneStrokes[self.undoneStrokes.length - 1][i].color = self.originalColorSelection;
            }
            self.showRedo(true);
            self.strokeSelected = false;
            self.completedStrokesInd.length = 0;
            self.lastStrokeEndInd = 0;
            redraw();
        }

        function colorLuminance(hex, lum) {
            if (hex === "#000000") {
                return "#848484";
            } else if (hex === "#ffffff") {
                return "#E6E6E6";
            } else {
                // validate hex string
                hex = String(hex).replace(/[^0-9a-f]/gi, '');
                if (hex.length < 6) {
                    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                }
                lum = lum || 0;

                // convert to decimal and change luminosity
                var rgb = "#", c, i;
                for (i = 0; i < 3; i++) {
                    c = parseInt(hex.substr(i * 2, 2), 16);
                    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                    rgb += ("00" + c).substr(c.length);
                }

                return rgb;
            }
        }

        function loadSvgFile(filenameToLoad) {
            var xmlhttp = new XMLHttpRequest;

            xmlhttp.open("GET", lq.getTenantUrl('DynamicContent/File/' + filenameToLoad), false);
            xmlhttp.send();

            var xmlDoc = xmlhttp.responseXML;

            var svgElement = xmlDoc.firstChild;
            var pathElements = svgElement.childNodes;
            for (var i = 0; i < pathElements.length; i++) {
                var path = pathElements[i];

                if (path.nodeName !== 'path') {
                    continue;
                }

                var strokeOpacity = path.getAttribute("stroke-opacity");
                var pathColor = path.getAttribute("stroke");
                var pathColor = combineColorWithOpacityToRgba(pathColor, strokeOpacity);
                var pathSize = path.getAttribute("stroke-width");
                var dAttArr = path.getAttribute("d").replace(/([^a-z])\s([^a-z])/gi, '$1,$2').replace(/([A-Z])\s/gi, '$1').split(" ");
                var xyArr = dAttArr[0].slice(1).split(",");

                self.clicks.push({ x: parseFloat(xyArr[0]), y: parseFloat(xyArr[1]), drag: false, size: pathSize, color: pathColor });

                if (path.getAttribute("class") === "line") {
                    xyArr = dAttArr[1].slice(1).split(",");
                    self.clicks.push({ x: parseFloat(xyArr[0]), y: parseFloat(xyArr[1]), drag: true, size: pathSize, color: pathColor });
                } else if (path.getAttribute("class") === "curve") {
                    for (var j = 1; j < dAttArr.length; j++) {
                        if (dAttArr[j].indexOf("Q") === 0) {
                            xyArr = dAttArr[j].slice(1).split(",");
                            self.clicks.push({ x: parseFloat(xyArr[0]), y: parseFloat(xyArr[1]), drag: true, size: pathSize, color: pathColor });
                            if (j === dAttArr.length - 1 && xyArr.length === 4) {
                                self.clicks.push({ x: parseFloat(xyArr[2]), y: parseFloat(xyArr[3]), drag: true, size: pathSize, color: pathColor });
                            }
                        } else if (j === dAttArr.length - 1) {
                            xyArr = dAttArr[j].split(",");
                            self.clicks.push({ x: parseFloat(xyArr[0]), y: parseFloat(xyArr[1]), drag: true, size: pathSize, color: pathColor });
                        }
                    }
                }
            }
            if (self.hasBgImage) {
                var bgdata = svgElement.childNodes[0];
                self.sizeAtTheTimeOfLoading = null;
                if (bgdata.nodeName === 'bgData') {

                    var bgWidth = bgdata.getAttribute("bgWidth");
                    var bgHeight = bgdata.getAttribute("bgHeight");
                    var cvWidth = bgdata.getAttribute("cvWidth");
                    var cvHeight = bgdata.getAttribute("cvHeight");
                    var bgLeft = bgdata.getAttribute("bgLeft");
                    var bgTop = bgdata.getAttribute("bgTop");

                    self.sizeAtTheTimeOfLoading = {
                        bgWidth: bgWidth,
                        bgHeight: bgHeight,
                        cvWidth: cvWidth,
                        cvHeight: cvHeight,
                        bgLeft: bgLeft,
                        bgTop: bgTop
                    };
                }
            }

            if (svgElement.getAttribute("class")) {
                var gridInfo = svgElement.getAttribute("class");

                if (gridInfo.indexOf("ontop=true") >= 0 && !self.gridOnTop) {
                    self.toggleOnTop();
                }

                self.gridSize = parseInt(gridInfo.replace(/^\D+/g, ''));
                redraw();

                if (gridInfo.indexOf("grid=true") >= 0) {
                    self._isGridShown = true;
                } else {
                    self._isGridShown = false;
                }
            }
            redraw();
        }

        function createSvg() {
            var svgns = "http://www.w3.org/2000/svg";
            var xlinkns = "http://www.w3.org/1999/xlink";

            self.svg = document.createElementNS(svgns, "svg");

            if (self.sizeAtTheTimeOfSaving && self.hasBgImage) {
                var bgPositionData = document.createElementNS(svgns, 'bgData');
                bgPositionData.setAttribute("bgWidth", self.sizeAtTheTimeOfSaving.bgWidth);
                bgPositionData.setAttribute("bgHeight", self.sizeAtTheTimeOfSaving.bgHeight);
                bgPositionData.setAttribute("cvWidth", self.sizeAtTheTimeOfSaving.cvWidth);
                bgPositionData.setAttribute("cvHeight", self.sizeAtTheTimeOfSaving.cvHeight);
                bgPositionData.setAttribute("bgLeft", self.sizeAtTheTimeOfSaving.bgLeft);
                bgPositionData.setAttribute("bgTop", self.sizeAtTheTimeOfSaving.bgTop);
                self.svg.appendChild(bgPositionData);
            }

            if (window.navigator.userAgent.indexOf("MSIE ") < 0) {
                self.svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', svgns);
            }
            self.svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', xlinkns);
            self.svg.setAttribute("width", self.canvas.width);
            self.svg.setAttribute("height", self.canvas.height);

            var hasDrawings = (self.clicks.length > 0);

            if (hasDrawings) {
                if (self.clicks[self.clicks.length - 1] && !self.clicks[self.clicks.length - 1].drag) {
                    self.clicks.pop();
                }

                var minX = Array.minProp(self.clicks, "x");
                var maxX = Array.maxProp(self.clicks, "x");
                var boxWidth = getBoxDimension(minX, maxX);
                var minY = Array.minProp(self.clicks, "y");
                var maxY = Array.maxProp(self.clicks, "y");
                var boxHeight = getBoxDimension(minY, maxY);

                self.svg.setAttribute("class", "grid=" + self._isGridShown + ", ontop=" + self.gridOnTop + ", size=" + self.gridSize);

                if (self._isGridShown && !self.gridOnTop) {
                    drawGridLayer(null, minX, minY, maxX, maxY);
                    self.svg.setAttribute("viewBox", (minX - 10) + " " + (minY - 10) + " " + (boxWidth + 20) + " " + (boxHeight + 20));
                    self.svg.setAttribute("width", boxWidth + 20);
                    self.svg.setAttribute("height", boxHeight + 20);
                    drawGridToSvg();
                }
            }

            if (self.uploadedImgBase64 && !self.backImageOnTop) {
                drawImageToSvg();
            }

            if (hasDrawings) {
                for (var i = 0; i < self.completedStrokesInd.length; i++) {

                    var path = document.createElementNS(svgns, "path");

                    var beg = self.completedStrokesInd[i].beg;
                    var end = self.completedStrokesInd[i].end;
                    var stroke = new Array();

                    for (var j = beg; j < end + 1; j++) {
                        stroke.push(self.clicks[j]);
                    }

                    path.setAttribute("stroke", getHexColorWithoutAlpha(stroke[0].color));
                    path.setAttribute("stroke-opacity", getColorAlpha(stroke[0].color));
                    path.setAttribute("stroke-width", stroke[0].size);
                    path.setAttribute("stroke-linejoin", "round");
                    path.setAttribute("stroke-linecap", "round");
                    path.setAttribute("fill", "none");

                    var dAtt = "M " + stroke[0].x + " " + stroke[0].y;

                    if (stroke.length < 3) {
                        dAtt += " L " + stroke[1].x + " " + stroke[1].y;
                        path.setAttribute("class", "line");
                    } else {
                        for (var k = 1; k < stroke.length - 2; k++) {
                            dAtt += " Q " + stroke[k].x + " " + stroke[k].y + " " + (stroke[k].x + stroke[k + 1].x) / 2 + " " + (stroke[k].y + stroke[k + 1].y) / 2;
                        }
                        dAtt += " Q " + stroke[k].x + " " + stroke[k].y + " " + stroke[k + 1].x + " " + stroke[k + 1].y;
                        path.setAttribute("class", "curve");
                    }
                    path.setAttribute("d", dAtt);
                    self.svg.appendChild(path);
                }

                if (self._isGridShown && self.gridOnTop) {
                    drawGridLayer(null, minX, minY, maxX, maxY);
                    self.svg.setAttribute("viewBox", (minX - 10) + " " + (minY - 10) + " " + (boxWidth + 20) + " " + (boxHeight + 20));
                    self.svg.setAttribute("width", boxWidth + 20);
                    self.svg.setAttribute("height", boxHeight + 20);
                    drawGridToSvg();
                }
            }

            if (self.uploadedImgBase64 && self.backImageOnTop) {
                drawImageToSvg();
            }

            function drawImageToSvg() {
                var image = document.createElementNS(svgns, "image");
                image.setAttributeNS(xlinkns, "xlink:href", self.uploadedImgBase64);
                image.setAttribute("x", 0);
                image.setAttribute("y", 0);

                var layer = getLayer('uploaded-image');
                image.setAttribute("width", layer.uploadedImg.width);
                image.setAttribute("height", layer.uploadedImg.height);

                self.svg.appendChild(image);
            }

            function drawGridToSvg() {
                for (var l = 0; l < self.gridLines.length; l++) {
                    self.svg.appendChild(self.gridLines[l]);
                }
            }

            return (new XMLSerializer).serializeToString(self.svg);
        }
        self.createSvg = createSvg;

        function createImage(exportCrop, imageType) {
            if (!exportCrop || !self.sizeAtTheTimeOfSaving)
                return $canvas[0].toDataURL(imageType);

            var cropX = self.sizeAtTheTimeOfSaving.bgLeft;
            var cropY = self.sizeAtTheTimeOfSaving.bgTop;
            var cropWidth = self.sizeAtTheTimeOfSaving.cvWidth;
            var cropHeight = self.sizeAtTheTimeOfSaving.cvHeight;

            var canvasHeight = $canvas[0].getBoundingClientRect().height;
            var canvasWidth = $canvas[0].getBoundingClientRect().width;

            // Without clamping the values the exported image is transparent in Safari
            if (cropX < 0) cropX = 0;
            if (cropY < 0) cropY = 0;
            if (cropHeight > canvasHeight) cropHeight = canvasHeight;
            if (cropWidth > canvasWidth) cropHeight = canvasWidth;

            var exportCanvas = document.createElement('canvas');
            var exportCanvasCtx = exportCanvas.getContext('2d');
            exportCanvas.width = cropWidth;
            exportCanvas.height = cropHeight;
            exportCanvasCtx.drawImage($canvas[0], cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

            return exportCanvas.toDataURL(imageType);
        }
        self.createImage = createImage;

        function setValue(value) {
            refreshLayers();

            if (!value) {
                return;
            }

            value = util.convertListOfKeyValuesToObject(value);
            if (typeof value.Url !== "undefined") {
                if (value.Url.length === 0) return;
                self.filenameToLoad = value.Url;
                loadSvgFile(self.filenameToLoad);
            } else if (typeof value.url !== "undefined") {
                if (value.url.length === 0) return;
                self.filenameToLoad = value.url;
                loadSvgFile(self.filenameToLoad);
            } else if (value.substring(value.length - 4, value.length).toLowerCase() === '.svg') {
                self.filenameToLoad = value;
                loadSvgFile(self.filenameToLoad);
            }
        }
        self.setValue = setValue;

        Array.minProp = function (array, prop) {
            var el = _.min(array, function (el) {
                return el[prop];
            });
            return el[prop];
        };

        Array.maxProp = function (array, prop) {
            var el = _.max(array, function (el) {
                return el[prop];
            });
            return el[prop];
        };

        function getBoxDimension(min, max) {
            if (min < 0) {
                if (max < 0) {
                    return Math.abs(min) - Math.abs(max);
                } else {
                    return Math.abs(min) + Math.abs(max);
                }
            } else {
                return max - min;
            }
        }

        function updateRequiredIndicator() {
            if (self.clicks.length !== 0)
                $($canvas[0].parentElement).addClass('hasValidValue');
            else
                $($canvas[0].parentElement).removeClass('hasValidValue');
        }

        self.updateRequiredIndicator = updateRequiredIndicator;

        function redraw(bgImgSrc, isNewBgImg, isClearBg) {
            if (self.context) {
                clearEverything();
                initializeLayers();
                drawBgImageAndContent(bgImgSrc, isNewBgImg, isClearBg);
                updateRequiredIndicator();
            }
        }

        function drawBgImageAndContent(bgImgSrc, isNewBgImg, isClearBg) {
            if ((!self.cachedBgImg || isNewBgImg) && bgImgSrc) {
                var img = new Image();
                img.onload = function() {
                    drawBgImageWithSize(this);
                    self.cachedBgImg = this;
                    redrawContent();
                };
                img.src = bgImgSrc;
            } else if (self.cachedBgImg && !isClearBg) {
                drawBgImageWithSize(self.cachedBgImg);
                redrawContent();
            } else {
                redrawContent();
                self.cachedBgImg = null;
            }
        }

        function clearEverything() {
            var p1 = self.context.transformedPoint(0, 0);
            var p2 = self.context.transformedPoint(self.canvas.width, self.canvas.height);
            self.context.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
        }

        function redrawContent() {
            if (self._isGridShown && !self.gridOnTop) {
                drawLayerToMainContext('grid');
            }

            if (self.useBackImage && !self.backImageOnTop && self.backImage) {
                drawLayerToMainContext('uploaded-image');
            }

            self.context.lineJoin = "round";
            self.context.lineCap = "round";

            for (i = self.lastStrokeEndInd; i < self.clicks.length; i++) {
                if ((typeof self.clicks[i + 1] !== 'undefined' && self.clicks[i + 1].drag === false) || (!self.paint && i === self.clicks.length - 1)) {
                    self.completedStrokesInd.push({ beg: self.lastStrokeEndInd, end: i });
                    self.lastStrokeEndInd = i + 1;
                }
            }

            for (i = 0; i < self.completedStrokesInd.length; i++) {
                drawProperStroke(self.clicks.slice(self.completedStrokesInd[i].beg, self.completedStrokesInd[i].end + 1));

            }

            for (var i = self.lastStrokeEndInd; i < self.clicks.length; i++) {
                self.context.beginPath();
                if (self.clicks[i].drag && i) {
                    self.context.moveTo(self.clicks[i - 1].x, self.clicks[i - 1].y);
                } else {
                    self.context.moveTo(self.clicks[i].x, self.clicks[i].y);
                }
                self.context.lineTo(self.clicks[i].x, self.clicks[i].y);
                self.context.moveTo(self.clicks[i].x, self.clicks[i].y);    //for linejoin & -cap in safari
                self.context.closePath();
                self.context.strokeStyle = hex2rgba(self.clicks[i].color);
                self.context.lineWidth = self.clicks[i].size;
                self.context.stroke();
            }

            if (self._isGridShown && self.gridOnTop) {
                drawLayerToMainContext('grid');
            }

            if (self.useBackImage && self.backImageOnTop && self.backImage) {
                drawLayerToMainContext('uploaded-image');
            }
        }

        function drawBgImageWithSize(img, layer) {
            self.sizeAtTheTimeOfSaving = null;
            var actualContext = self.context;
            if (!img) {
                return;
            }
            if (layer)
                actualContext = layer.context;

            if (self.sizeAtTheTimeOfLoading && self.hasBgImage) {
                actualContext.drawImage(img, 0, 0,  self.sizeAtTheTimeOfLoading.bgWidth, self.sizeAtTheTimeOfLoading.bgHeight, // source rectangle
                    self.sizeAtTheTimeOfLoading.bgLeft, self.sizeAtTheTimeOfLoading.bgTop, self.sizeAtTheTimeOfLoading.cvWidth, self.sizeAtTheTimeOfLoading.cvHeight);

                self.sizeAtTheTimeOfSaving = self.sizeAtTheTimeOfLoading;
                return;
            }

            if (self.disableMovingBg) {
                setupNonMovinBackground($(self.canvas), img.src);
                return;
            }

            // Stretch Image
            if (self.reqDataFromParent.selectedResizeOption === 'Stretch Image') {
                actualContext.drawImage(img, 0, 0,  img.width,    img.height,     // source rectangle
                    0, 0, self.canvas.width, self.canvas.height);
                self.sizeAtTheTimeOfSaving = {
                    bgWidth: img.width,
                    bgHeight: img.height,
                    cvWidth: self.canvas.width,
                    cvHeight: self.canvas.height,
                    bgLeft: 0,
                    bgTop: 0
                };
                return;
            }
            // No-Resize
            else if (self.reqDataFromParent.selectedResizeOption === 'No-Resize') {
                actualContext.drawImage(img, 0, 0);
                self.sizeAtTheTimeOfSaving = {
                    bgWidth: img.width,
                    bgHeight: img.height,
                    cvWidth: img.width,
                    cvHeight: img.height,
                    bgLeft: 0,
                    bgTop: 0
                };
                return;
            }

            var condition = false;
            var ratio1 = img.width/img.height;
            var newWidth = ratio1 * self.canvas.height;

            var ratio2 = img.height/img.width;
            var newHeight = ratio2 * self.canvas.width;

            if ((newHeight > self.canvas.height && self.reqDataFromParent.selectedResizeOption === 'Keep Ratio, Show Complete Image')
                || (newWidth > self.canvas.width && self.reqDataFromParent.selectedResizeOption === 'fillKeepRatio')) {
                condition = true;
            }

            // Keep Ratio, Show Complete Image OR Fill, keep ratio, depending on condition
            if (condition) {
                var offsetForCentering = (self.canvas.width - newWidth) / 2;

                actualContext.drawImage(img, 0, 0,  img.width,    img.height,     // source rectangle
                    offsetForCentering, 0, newWidth, self.canvas.height);
                self.sizeAtTheTimeOfSaving = {
                    bgWidth: img.width,
                    bgHeight: img.height,
                    cvWidth: newWidth,
                    cvHeight: self.canvas.height,
                    bgLeft: offsetForCentering,
                    bgTop: 0
                };

            } else {
                var offsetForCentering = (self.canvas.height - newHeight) / 2;

                actualContext.drawImage(img, 0, 0,  img.width,    img.height,     // source rectangle
                    0, offsetForCentering, self.canvas.width, newHeight);
                self.sizeAtTheTimeOfSaving = {
                    bgWidth: img.width,
                    bgHeight: img.height,
                    cvWidth: self.canvas.width,
                    cvHeight: newHeight,
                    bgLeft: 0,
                    bgTop: offsetForCentering
                };
            }
        }

        function setupNonMovinBackground ($canvas, src) {
            $canvas
                .css('background-image', 'url(' + src + ')');

            if (self.reqDataFromParent.selectedResizeOption === 'Stretch Image')
                $canvas.css('background-size', '100% 100%');
            else if (self.reqDataFromParent.selectedResizeOption === 'Keep Ratio, Show Complete Image')
                $canvas.css({
                    'background-size': 'contain',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center center'
                });
            else if (self.reqDataFromParent.selectedResizeOption === 'No-Resize')
                $canvas.css({
                    'background-size': 'auto',
                    'background-repeat': 'no-repeat'
                });
            else if (self.reqDataFromParent.selectedResizeOption === 'fillKeepRatio')
                $canvas.css({
                    'background-size': 'cover',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center center'
                });
        }

        var layers = [];
        function createLayers() {
            if (self._isGridShown) {
                createGridLayer();
            }

            if (self.useBackImage) {
                createUploadedImageLayer();
            }
        }

        function drawLayer(layer) {
            if (self.canvas) {
                layer.canvas.width = self.canvas.clientWidth; //clears the current canvas
                layer.canvas.height = self.canvas.clientHeight; //clears the current canvas
            } else {
                layer.canvas.width = layer.canvas.width;
                layer.canvas.height = layer.canvas.height;
            }
            self.context.applyTransformTo(layer.context);
            layer.draw();
        }

        function refreshLayers() {
            _.forEach(layers, function (layer) {
                if (layer.currentTimeoutId) {
                    window.clearTimeout(layer.currentTimeoutId);
                }
                if (layer.drawInterval) {
                    layer.currentTimeoutId = window.setTimeout(function () {
                        drawLayer(layer);
                        redraw(); //if needed for performance, layers with the same interval could be batched with a single redraw (of course this function 'refreshLayers' needs to be changed then)
                    }, layer.drawInterval);
                } else {
                    drawLayer(layer);
                }
            });
        }

        function initializeLayers() {
            _.forEach(layers, function (layer) {
                if (!layer.isInitialized) {
                    if (typeof layer.initialize === "function") {
                        layer.initialize();
                    }
                    drawLayer(layer);
                    layer.isInitialized = true;
                }
            });
        }

        function getLayer(layerName) {
            return _.find(layers, function (layer) {
                return layer.name == layerName;
            });
        }

        function drawLayerToMainContext(layerName) {
            var layer = getLayer(layerName);

            if (!layer && layerName === 'grid') {
                createGridLayer();
                layer = getLayer(layerName);
                drawLayer(layer);
            }

            self.context.save();
            var transformMatrix = self.context.getTransformMatrix();
            var layerMatrix = layer.context.getTransformMatrix();
            var layerScale = transformMatrix.a / layerMatrix.a;
            var newTranslateX = ((transformMatrix.e) - (layerMatrix.e * layerScale));
            var newTranslateY = ((transformMatrix.f) - (layerMatrix.f * layerScale));

            self.context.setTransform(layerScale, 0, 0, layerScale, newTranslateX, newTranslateY);
            self.context.drawImage(layer.canvas, 0, 0);
            self.context.restore();
        }

        function createLayer(layerName) {
            var layerCanvas = document.createElement('canvas');
            layerCanvas.height = self.canvas.height;
            layerCanvas.width = self.canvas.width;

            var layerContext = layerCanvas.getContext('2d');
            trackTransforms(layerContext);
            layerCanvas.width = layerCanvas.width;

            var layer = {
                name: layerName,
                canvas: layerCanvas,
                context: layerContext
            };

            layers.push(layer);

            return layer;
        }

        function createGridLayer() {
            var layer = createLayer('grid');
            layer.drawInterval = 300; //could be set to 0 for fast machines (= no delay), for iPad 300 is recommended
            layer.draw = function () { drawGridLayer(layer); };
        }

        function drawGridLayer(layer, p1x, p1y, p2x, p2y) {
            var svgns = "http://www.w3.org/2000/svg";
            self.gridLines = [];
            var drawGridLinesToSvg = false;
            var xSpacing;
            var ySpacing;
            var i, j;
            var p1 = self.context.transformedPoint(0, 0);
            var p2 = self.context.transformedPoint(self.canvas.width, self.canvas.height);

            if (p1x && p1y && p2x && p2y) {
                p1.x = p1x - 20;
                p1.y = p1y - 20;
                p2.x = p2x + 20;
                p2.y = p2y + 20;
                drawGridLinesToSvg = true;
            }
            var lineWidth = 1;
            var lineColor = "#000000";
            var lineOpacity = 1;

            if (self.useGraphPaper == true) {
                xSpacing = 3;
                ySpacing = 3;
                if (layer) {
                    layer.context.lineWidth = 0.5;
                }
                lineWidth = 0.5;
            } else {
                xSpacing = 10;
                ySpacing = 10;
                if (layer) {
                    layer.context.lineWidth = 1;
                    layer.context.strokeStyle = hex2rgba("#E6E6E6");
                }
                lineWidth = 1;
                lineColor = "#E6E6E6";
                lineOpacity = 1;
            }

            if (self.useGraphPaper == false) {
                for (i = p1.x - (p1.x % (self.gridSize * xSpacing)) ; i < p2.x; i += self.gridSize * xSpacing) {     //i = edge - offset
                    if (drawGridLinesToSvg) {
                        var gridLine = document.createElementNS(svgns, "line");
                        gridLine.setAttribute("class", "gridline");
                        gridLine.setAttribute("stroke", lineColor);
                        gridLine.setAttribute("stroke-width", lineWidth);
                        gridLine.setAttribute("stroke-opacity", lineOpacity);
                        gridLine.setAttribute("x1", i);
                        gridLine.setAttribute("y1", p1.y);
                        gridLine.setAttribute("x2", i);
                        gridLine.setAttribute("y2", p2.y);
                        self.gridLines.push(gridLine);
                    } else {
                        layer.context.beginPath();
                        layer.context.moveTo(i, p1.y);
                        layer.context.lineTo(i, p2.y);
                        layer.context.closePath();
                        layer.context.stroke();
                    }
                }
                for (i = p1.y - (p1.y % (self.gridSize * ySpacing)) ; i < p2.y; i += self.gridSize * ySpacing) {
                    if (drawGridLinesToSvg) {
                        var gridLine = document.createElementNS(svgns, "line");
                        gridLine.setAttribute("class", "gridline");
                        gridLine.setAttribute("stroke", lineColor);
                        gridLine.setAttribute("stroke-width", lineWidth);
                        gridLine.setAttribute("stroke-opacity", lineOpacity);
                        gridLine.setAttribute("x1", p1.x);
                        gridLine.setAttribute("y1", i);
                        gridLine.setAttribute("x2", p2.x);
                        gridLine.setAttribute("y2", i);
                        self.gridLines.push(gridLine);
                    } else {
                        layer.context.beginPath();
                        layer.context.moveTo(p1.x, i);
                        layer.context.lineTo(p2.x, i);
                        layer.context.closePath();
                        layer.context.stroke();
                    }
                }
            } else {
                for (var thickness = 1; thickness <= 3; thickness++) {
                    //written with a minimum of context changes -> for performance
                    switch (thickness) {
                        case 1:
                            if (layer) {
                                layer.context.strokeStyle = hex2rgba("#FFE1BDBB");
                            }
                            lineColor = "#FFE1BD";
                            lineOpacity = 0.74;
                            break;
                        case 2:
                            if (layer) {
                                layer.context.strokeStyle = hex2rgba("#FFC682BB");
                            }
                            lineColor = "#FFC682";
                            lineOpacity = 0.74;
                            break;
                        case 3:
                            if (layer) {
                                layer.context.strokeStyle = hex2rgba("#D67C11BB");
                            }
                            lineColor = "#D67C11";
                            lineOpacity = 0.74;
                            break;
                    }

                    var start = {
                        x: p1.x - 80,
                        y: p1.y - 80
                    };
                    var end = {
                        x: p2.x + 80,
                        y: p2.y + 80
                    };

                    for (i = start.x - (start.x % (self.gridSize * xSpacing)) ; i < end.x; i += self.gridSize * xSpacing) {     //i = edge - offset
                        if (!(thickness == 3 && i % ((self.gridSize * 10 * xSpacing)) == 0)
                            && !(thickness == 2 && i % ((self.gridSize * 10 * xSpacing) / 2) == 0)
                            && !(thickness == 1)) {
                            continue;
                        }

                        if (drawGridLinesToSvg) {
                            var gridLine = document.createElementNS(svgns, "line");
                            gridLine.setAttribute("class", "gridline");
                            gridLine.setAttribute("stroke", lineColor);
                            gridLine.setAttribute("stroke-width", lineWidth);
                            gridLine.setAttribute("stroke-opacity", lineOpacity);
                            gridLine.setAttribute("x1", i);
                            gridLine.setAttribute("y1", start.y);
                            gridLine.setAttribute("x2", i);
                            gridLine.setAttribute("y2", end.y);
                            self.gridLines.push(gridLine);
                        } else {
                            layer.context.beginPath();
                            layer.context.moveTo(i, start.y);
                            layer.context.lineTo(i, end.y);
                            layer.context.closePath();
                            layer.context.stroke();
                        }
                    }
                    for (i = start.y - (start.y % (self.gridSize * ySpacing)) ; i < end.y; i += self.gridSize * ySpacing) {
                        if (!(thickness == 3 && i % ((self.gridSize * 10 * ySpacing)) == 0)
                            && !(thickness == 2 && i % ((self.gridSize * 10 * ySpacing) / 2) == 0)
                            && !(thickness == 1)) {
                            continue;
                        }

                        if (drawGridLinesToSvg) {
                            var gridLine = document.createElementNS(svgns, "line");
                            gridLine.setAttribute("class", "gridline");
                            gridLine.setAttribute("stroke", lineColor);
                            gridLine.setAttribute("stroke-width", lineWidth);
                            gridLine.setAttribute("stroke-opacity", lineOpacity);
                            gridLine.setAttribute("x1", start.x);
                            gridLine.setAttribute("y1", i);
                            gridLine.setAttribute("x2", end.x);
                            gridLine.setAttribute("y2", i);
                            self.gridLines.push(gridLine);
                        } else {
                            layer.context.beginPath();
                            layer.context.moveTo(start.x, i);
                            layer.context.lineTo(end.x, i);
                            layer.context.closePath();
                            layer.context.stroke();
                        }
                    }
                }

                if (self.useGraphPaperScale && self.graphPaperScaleParameter) {
                    var scale = parseInt(self.parameters.getValue(self.graphPaperScaleParameter));
                    if (layer) {
                        layer.context.strokeStyle = "#000000";
                        layer.context.lineWidth = 1;
                    }

                    lineColor = "#000000";
                    lineOpacity = 1;
                    lineWidth = 1;

                    var offset = -(self.gridSize * 10 * xSpacing); //don't start drawing scrale from x: 0, y:0

                    if (!isNaN(scale)) {
                        var startX = p1.x - 10,
                            startY = p1.y - 10,
                            stopX = p2.x + 10,
                            stopY = p2.y + 10;

                        for (i = startX - (startX % (self.gridSize * xSpacing)) ; i < (stopX) ; i += self.gridSize * xSpacing) {     //i = edge - offset
                            if ((i + offset) % ((self.gridSize * 10 * xSpacing) * scale) != 0) {
                                continue;
                            }

                            for (j = startY - (startY % (self.gridSize * ySpacing)) ; j < (stopY) ; j += self.gridSize * ySpacing) {
                                if ((j + offset) % ((self.gridSize * 10 * ySpacing) * scale) != 0) {
                                    continue;
                                }

                                if (drawGridLinesToSvg) {
                                    var gridLine = document.createElementNS(svgns, "line");
                                    gridLine.setAttribute("class", "gridline");
                                    gridLine.setAttribute("stroke", lineColor);
                                    gridLine.setAttribute("stroke-width", lineWidth);
                                    gridLine.setAttribute("stroke-opacity", lineOpacity);
                                    gridLine.setAttribute("x1", i - 5);
                                    gridLine.setAttribute("y1", j);
                                    gridLine.setAttribute("x2", i + 5);
                                    gridLine.setAttribute("y2", j);
                                    self.gridLines.push(gridLine);

                                    gridLine = document.createElementNS(svgns, "line");
                                    gridLine.setAttribute("class", "gridline");
                                    gridLine.setAttribute("stroke", lineColor);
                                    gridLine.setAttribute("stroke-width", lineWidth);
                                    gridLine.setAttribute("stroke-opacity", lineOpacity);
                                    gridLine.setAttribute("x1", i);
                                    gridLine.setAttribute("y1", j - 5);
                                    gridLine.setAttribute("x2", i);
                                    gridLine.setAttribute("y2", j + 5);
                                    self.gridLines.push(gridLine);
                                } else {
                                    layer.context.beginPath();
                                    layer.context.moveTo(i - 5, j);
                                    layer.context.lineTo(i + 5, j);
                                    layer.context.closePath();
                                    layer.context.stroke();

                                    layer.context.beginPath();
                                    layer.context.moveTo(i, j - 5);
                                    layer.context.lineTo(i, j + 5);
                                    layer.context.closePath();
                                    layer.context.stroke();
                                }
                            }
                        }
                    }
                }
            }
        }

        function endsWith(str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function createUploadedImageLayer() {
            if (!self.backImage)
                return;
            var layer = createLayer('uploaded-image');
            layer.drawInterval = 300; //could be set to 0 for fast machines (= no delay), for iPad 300 is recommended
            layer.initialize = function () {
                layer.uploadedImg = new Image();
                layer.uploadedImg.onload = function () {
                    layer.canvas.width = layer.canvas.width; //clear canvas
                    layer.draw();
                    redraw();
                    $.ajax(lq.getTenantUploads(self.backImage), {
                        success: function (r, textStatus, jqXHR) {
                            if (endsWith(self.backImage, '.svg')) {
                                var data = btoa(jqXHR.responseText);
                                data = 'data:image/svg+xml;base64,' + data;
                                self.uploadedImgBase64 = data;
                            }
                        },
                        mimeType: "text/plain; charset=x-user-defined"
                    });
                };
                layer.uploadedImg.src = lq.getTenantUploads(self.backImage);
            };
            layer.draw = function () {
                drawBgImageWithSize(layer.uploadedImg, layer);
            };
        }

        function drawProperStroke(stroke) {

            if (stroke.length < 3) {
                self.context.beginPath();
                self.context.moveTo(stroke[0].x, stroke[0].y);
                self.context.lineTo(stroke[1].x, stroke[1].y);
                self.context.moveTo(stroke[1].x, stroke[1].y);      //for linejoin & -cap in safari
                self.context.closePath();
                self.context.strokeStyle = hex2rgba(stroke[0].color);
                self.context.lineWidth = stroke[0].size;
                self.context.stroke();

                return;
            }

            self.context.beginPath();
            self.context.moveTo(stroke[0].x, stroke[0].y);

            for (var i = 1; i < stroke.length - 2; i++) {
                self.context.quadraticCurveTo(stroke[i].x, stroke[i].y, (stroke[i].x + stroke[i + 1].x) / 2, (stroke[i].y + stroke[i + 1].y) / 2);
            }

            self.context.quadraticCurveTo(stroke[i].x, stroke[i].y, stroke[i + 1].x, stroke[i + 1].y);      //last 2 points

            self.context.strokeStyle = hex2rgba(stroke[0].color);
            self.context.lineWidth = stroke[0].size;
            self.context.stroke();
        }

        function adjustStrokeForSafari(stroke) {
            var adjustment = 0.001;

            for (i = 0; i < stroke.length; i++) {
                if (typeof stroke[i + 1] !== 'undefined') {
                    if (stroke[i].x === stroke[i + 1].x) {
                        //stroke[i].x += (Math.random() / 10);
                        stroke[i].x += adjustment;
                    }
                    if (stroke[i].y === stroke[i + 1].y) {
                        //stroke[i].y += (Math.random() / 10);
                        stroke[i].y += adjustment;
                    }
                }
            }

            return stroke;
        }

        function trackTransforms(ctx) {
            var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
            var xform = svg.createSVGMatrix();

            var scale = ctx.scale;
            ctx.scale = function (sx, sy) {
                xform = xform.scaleNonUniform(sx, sy);
                return scale.call(ctx, sx, sy);
            };

            var translate = ctx.translate;
            ctx.translate = function (dx, dy) {
                xform = xform.translate(dx, dy);
                return translate.call(ctx, dx, dy);
            };

            var pt = svg.createSVGPoint();
            ctx.transformedPoint = function (x, y) {
                pt.x = x;
                pt.y = y;
                return pt.matrixTransform(xform.inverse());
            };

            ctx.setXForm = function (xf) {
                xform = xf;
            };

            ctx.resetTracking = function () {
                xform = svg.createSVGMatrix();
            };

            ctx.applyTransformTo = function (otherCtx) {
                otherCtx.setTransform(xform.a, xform.b, xform.c, xform.d, xform.e, xform.f);
                if (otherCtx.setXForm) {
                    otherCtx.setXForm(xform);
                }
            };

            ctx.getTransformMatrix = function () {
                return xform;
            };
        }

        function insertStylePicker() {
        var colors = new Array('#F5D870', '#EE9F39', '#DD6655', '#E76FA0'
                             , '#A872D5', '#6151C8', '#2A99EA', '#0674BC'
                             , '#A8D26E', '#60A55A', '#3F7451', '#304388'
                             , '#FFFFFF', '#969696', '#333333', '#A47D46');

            var colorIndices = new Array();
            if (self.colorIndicesToAllow) {
                var indices = self.colorIndicesToAllow.split(',');
                _.each(indices, function (index) {
                    colorIndices.push(parseInt(index.trim()));
                });
            }
            if (colorIndices.length === 0) {
                colorIndices = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15);
            }

            var sizesMark = new Array(4, 5, 6, 7, 8, 9, 10, 12, 15, 20, 25, 30);
            var sizesDraw = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15);

            self.$stylePickerContainer.find(".sketchStylePicker").each(function () {
                var $picker = $(this);
                var id = $picker.attr('id');

                var sizes;
                var img;

                if (id === 'pickMark') {
                    sizes = sizesMark;
                    img = '#imgMarker';
                }
                else {
                    sizes = sizesDraw;
                    img = '#imgDraw';
                }

                $picker.find('.sketchStylePopup').remove();

                var div = "";

                if (id === 'pickMark') {
                    div = "<div class='sketchStylePopup sketchStylePopupMarker'>"
                        + "<div class = 'centerBorder'/>"
                        + " <div class='sketchStyleThickness'>";
                } else {
                    div = "<div class='sketchStylePopup sketchStylePopupPencil'>"
                        + "<div class = 'centerBorder'/>"
                        + " <div class='sketchStyleThickness'>";
                }

                //SIZES
                for (var i = 0; i < sizes.length; i++) {
                    div += "<input type='radio' id='size_radio" + i + id + "' name='radioSizes" + id + "' value='" + sizes[i] + "'";

                    if (id === 'pickDraw' && sizes[i] == self.lineSize) {
                        div += " checked";
                    } else if (id === 'pickMark' && sizes[i] == self.lineSizeMarker) {
                        div += " checked";
                    }

                    div += "><label for='size_radio" + i + id + "'><div class='style-thickness_" + sizes[i] + "'></div></label>";
                }

                div += "</div>"
                        + "<div class='sketchStyleColors'>";

                //COLORS
                for (var i = 0; i < colors.length; i++) {
                    if (_.find(colorIndices, function (colorI) { return colorI == i; }) === undefined) {
                        continue;
                    }

                    if (id === 'pickMark') { colors[i] += '99'; }
                    else if (colors[i].substring(colors[i].length - 2, colors[i].length) === '99') {
                        colors[i] = colors[i].substring(0, colors[i].length - 2);
                    }

                    div += "<div class='colorRadio'><input type='radio' id='color_radio" + i + id + "' name='radioColors" + id + "' value='" + colors[i] + "'";

                    if (id === 'pickMark' && model.defaultMarkerColor) {
                        if (hex2rgba(colors[i]) === model.defaultMarkerColor) {
                            div += " checked";
                        }
                    } else if (id !== 'pickMark' && model.defaultPenColor) {
                        if (hex2rgba(colors[i]) === model.defaultPenColor) {
                            div += " checked";
                        }
                    } else {
                        if (colors[i] === '#000000' || colors[i] === '#00000099') {
                            div += " checked";
                        }
                    }

                    div += "><label for='color_radio" + i + id + "' style='background-color:" + hex2rgba(colors[i] !== "#FFFFFF" ? colors[i] : "#ECECED") + "'></label></div>";
                }

                div += "</div>"
                        + "<div class='clear'"
                        + "</div>";

                $(this).append(div);

                /* event to push changed radiobutton*/
                /* size */
                $picker.find("input:radio[name*='radioSizes']").on('change',
                function () {
                    var selectedValue = $picker.find("input[type='radio'][name*='radioSizes']:checked").val();
                    var slider = $picker.find('input[name*="lineSize"]');

                    slider.val(selectedValue);
                    slider.change();

                    if (id === 'pickMark') {
                        self.lineSizeMarker = selectedValue;
                    } else {
                        self.lineSize = selectedValue;
                    }
                });

                /* color */
                $picker.find("input:radio[name*='radioColors']").on('change',
                function () {
                    var selectedValue = $picker.find("input[type='radio'][name*='radioColors']:checked").val();
                    var colorInput = $picker.find('input[id*="colPicker"]');

                    colorInput.val(selectedValue);
                    colorInput.change();

                    if (id === 'pickMark') {
                        self.curColorMarker = selectedValue;
                        $(self.$toolbarButtons.find("#" + self.btnMarker.id)[0].contentDocument.getElementsByClassName("color")).attr("fill", hex2rgba(selectedValue !== "#FFFFFF99" ? selectedValue : "#ECECED99"));
                    } else {
                        self.curColor = selectedValue;
                        $(self.$toolbarButtons.find("#" + self.btnDraw.id)[0].contentDocument.getElementsByClassName("color")).attr("fill", hex2rgba(selectedValue !== "#FFFFFF" ? selectedValue : "#ECECED"));
                    }
                });

                /* events to show/hide style picker */
                if (id === 'pickMark') {
                    self.$markerTool[0].addEventListener('markOpened', function (e) {
                        if (is_touch_device() == true && e.type === 'click') { return };
                        self.$markerTool.find('.sketchStylePopupMarker').closest('div[id!=' + id + '][id*=pick]').find('.sketchStylePopup').hide();
                        self.$stylePickerContainer.find('.sketchStylePopupMarker').toggle();
                    }, false);
                    self.$markerTool.parents('table:eq(0)').parent().on('mousedown touchstart', function (e) {
                        if (!e.target.isSameNode(self.$markerTool[0]))
                            self.$stylePickerContainer.find('.sketchStylePopupMarker').hide();
                    }).find('.sketchStylePickerMarker').on('mousedown touchstart', function (e) { e.stopPropagation(); });
                } else {
                    self.$penTool[0].addEventListener('penOpened', function (e) {
                        if (is_touch_device() == true && e.type === 'click') { return };
                        self.$penTool.find('.sketchStylePopupPencil').closest('div[id!=' + id + '][id*=pick]').find('.sketchStylePopup').hide();
                        self.$stylePickerContainer.find('.sketchStylePopupPencil').toggle();
                    }, false);
                    self.$penTool.parents('table:eq(0)').parent().on('mousedown touchstart', function (e) {
                        if (!e.target.isSameNode(self.$penTool[0]))
                            self.$stylePickerContainer.find('.sketchStylePopupPencil').hide();
                    }).find('.sketchStylePickerPencil').on('mousedown touchstart', function (e) { e.stopPropagation(); });
                }
            });
        };

        function hex2rgba(hexStr) {
            if (typeof hexStr === 'undefined') { return; };

            if (hexStr.substr(0, 3) === 'rgb') {
                return hexStr;
            }

            if (hexStr.length == 7) {
                hexStr += 'ff';
            }

            var hex = parseInt(hexStr.substring(1, 7), 16);
            var r = (hex & 0xff0000) >> 16;
            var g = (hex & 0x00ff00) >> 8;
            var b = hex & 0x0000ff;

            var hex = parseInt(hexStr.substring(7), 16);
            var a = hex & 0xff;

            var rgba = "rgba(" + r + ", " + g + ", " + b + ", " + (a / 255) + ")";

            return rgba;
        }

        function getColorAlpha(color) {
            if (typeof color === 'undefined') { return 0; };

            if (color.substr(0, 4) === 'rgba') {
                return parseFloat(color.split(',')[3].replace(')', ''));
            } else if (color.substr(0, 3) === 'rgb') {
                return 1;
            }

            if (color.length === 7) {
                return 1;
            }

            var hex = parseInt(color.substring(7), 16);
            var a = hex & 0xff;
            return (a / 255);
        }

        function getHexColorWithoutAlpha(color) {
            if (typeof color === 'undefined') { return; };

            if (color.substr(0, 3) === 'rgb') {
                color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
                return (color && color.length === 4) ? "#" +
                    ("0" + parseInt(color[1], 10).toString(16)).slice(-2) +
                    ("0" + parseInt(color[2], 10).toString(16)).slice(-2) +
                    ("0" + parseInt(color[3], 10).toString(16)).slice(-2) : '';
            }

            return '#' + color.substring(1, 7);
        }

        function combineColorWithOpacityToRgba(color, opacity) {
            if (color.substr(0, 1) === '#') {
                color = hex2rgba(color);
            }

            if (opacity == undefined) {
                return color;
            }

            var colorParts = color.split(',');
            var r = parseInt(colorParts[0].replace('rgba(', ''));
            var g = parseInt(colorParts[1]);
            var b = parseInt(colorParts[2]);
            return "rgba(" + r + "," + g + "," + b + "," + opacity + ")";
        }

        /*credit: http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
            fixed: http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript#comment18446405_4819886
        */

        function is_touch_device() {
            return 'ontouchstart' in window || !!(window.navigator.msMaxTouchPoints);
        };

        return self;
    }

    return CanvasMorph;
});
